module.exports = __webpack_public_path__ + "media/images/athletes/1991-01630108372073ef1d5bcb211107412f.png";